define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var ecAdminRoles = ["Engineering Change Administrator"];
	var ecEditRoles = ecAdminRoles.concat(["Engineering Change Editor"]);

	csiAccess.addViewRoles({
		"_CS_Data":{
			"AllECs":{
				"Delete":access(full(ecAdminRoles)),
				"NewEngineeringChange":access(full(ecAdminRoles))
			}
		},
		"EngineeringChange": {
			"StateHeader":{
				"ECApprovedToDraft":access(full(ecEditRoles)),
				"ECBackToDraft":access(full(ecEditRoles)),
				"ECReviewToDraft":access(full(ecEditRoles)),
				"ECToApproved":access(full(ecEditRoles)),
				"ECToCanceled":access(full(ecEditRoles)),
				"ECToReview":access(full(ecEditRoles))
			}
		},
		"Product": {
			"ProductEngineeringChange":{
				"AddToExistingEngineeringChange":access(full(ecEditRoles)),
				"NewEngineeringChange":access(full(ecAdminRoles))
			}
		},
		"StructureItem": {
			"HierarchyEngineeringChange":{
				"NewEngineeringChange":access(full(ecAdminRoles))
			}
		},
		"Material": {
			"MaterialEngineeringChange":{
				"AddToExistingEngineeringChange":access(full(ecEditRoles)),
				"NewEngineeringChange":access(full(ecAdminRoles))
			}
		},
		"MaterialSecurityGroup": {
			"MSGEngineeringChange":{
				"NewEngineeringChange":access(full(ecAdminRoles))
			}
		},
	});
});